import React, { useMemo, useRef, useState, forwardRef, useEffect } from "react";
import { ErrorMessage } from "formik";
import ReactSelect from 'react-select';
import { mobileCode } from "../../assets/CountryCode";
import axiosInstance from "../../Services/axiosCommon";
import Select from "react-select";
import { t } from "i18next";
import moment from "moment";

export function NuInput(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
    color= "black",
    px= "6"
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`px-${px} py-2 ${width}`}>
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${disabled === true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}

export function NuInputLogin(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
    color= "black",
    px= "6"
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`px-${px}  ${width}`}>
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3  rounded-3xl outline-baseColor-primary ${disabled === true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}

export function NuInputNew(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
    color= "black",
    px= "6"
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`px-${px}  ${width}`}>
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border border-gray-300 w-full h-10 px-3  rounded-[10px] outline-none ${disabled === true? "bg-gray-200 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}



export function NuInputValue(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,
    disabled,
    width,
    color = "black",
    px = "6"
  } = props;

  const formikValue = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik?.errors?.[name];

  const [formattedValue, setFormattedValue] = useState("");

  useEffect(() => {
    if (type === "number" && (formikValue || formikValue === 0)) {
      const number = Number(formikValue);
      setFormattedValue(number.toLocaleString("en-US"));
    } else {
      setFormattedValue(formikValue);
    }
  }, [formikValue]);

  const handleFormattedChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas
    if (!isNaN(rawValue)) {
      formik.setFieldValue(name, rawValue);
    }
  };

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input
        disabled={!!disabled}
        placeholder={placeholder}
        type={type === "number" ? "text" : type} // change to text if number type
        name={name}
        max={max || ""}
        min={min || ""}
        value={type === "number" ? formattedValue : value || formikValue}
        onChange={type === "number" ? handleFormattedChange : onChange || handleChangeFunc}
        className={`text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none ${
          disabled ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">{formikErrors}</span>
      ) : null}
    </div>
  );
}


export function NuInputToggle(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
    color= "black",
    px= "6",
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  const [toggleEye,setToggleEye] = useState(false);
  // console.log(max, "date");
  return (
    <div className={`px-${px} py-2 ${width}`}>
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <div
        className={`${
          disabled === true ? "bg-slate-100 cursor-not-allowed" : ""
        } text-xs bg-white 2xl:text-sm font-medium border w-full h-10 px-3  mt-2 rounded-3xl overflow-hidden flex justify-between items-center`}
      >
        <input
          disabled={disabled ? true : false}
          // id={name}
          placeholder={placeholder}
          type={toggleEye == true ? "text" : "password"}
          name={name}
          max={max || ""}
          min={min || ""}
          value={value || formikValues}
          onChange={onChange || handleChangeFunc}
          // onBlur={handleBlur}
          className={` outline-none flex-1 h-full ${
            disabled === true ? "bg-slate-100 cursor-not-allowed" : ""
          }`}
        />
        {toggleEye == true ? (
          <div
            className=" w-5 h-5   cursor-pointer "
            onClick={() => setToggleEye(!toggleEye)}
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0" />

              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M9.60997 9.60714C8.05503 10.4549 7 12.1043 7 14C7 16.7614 9.23858 19 12 19C13.8966 19 15.5466 17.944 16.3941 16.3878M21 14C21 9.02944 16.9706 5 12 5C11.5582 5 11.1238 5.03184 10.699 5.09334M3 14C3 11.0069 4.46104 8.35513 6.70883 6.71886M3 3L21 21"
                  stroke="#b91c1c"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />{" "}
              </g>
            </svg>
          </div>
        ) : (
          <div
            className=" w-5 h-5   cursor-pointer "
            onClick={() => setToggleEye(!toggleEye)}
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0" />

              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
                  stroke="#b91c1c"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />{" "}
              </g>
            </svg>
          </div>
        )}
      </div>
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}

export function NuInputWithError(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
    color= "black",
    px= "6",
    ErrMessage
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`px-${px} py-2 ${width}`}>
      <div className="flex">
      <label htmlFor={name} className={`text-xs 2xl:text-sm text-${color}`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <p className="pl-2 text-xs font-semibold text-red-500 ">{ErrMessage}</p>
      </div>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none ${disabled === true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {/* <ErrorMessage name={name}> 
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
       </ErrorMessage> */}
    </div>
  );
}

export function NuInputCurrency(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none ${disabled == true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {/* <ErrorMessage name={name}> 
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
       </ErrorMessage> */}
    </div>
  );
}

export function SupplierNuInput(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`pl-6 pr-3 py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none ${disabled == true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {/* <ErrorMessage name={name}> 
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
       </ErrorMessage> */}
    </div>
  );
}

export function NuInputSetting(props) {
  let {
    ref,
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  const focus = useRef('');
    const onFocus = () =>{
      focus?.current?.focus();
    }
  // console.log(max, "date");
  return (
    <div className={`flex items-center bg-white border border-gray-300 rounded-md shadow-sm mt-2`}>
      {/* <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label> */}
      <input
          // id={name}
        ref={focus} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `flex-grow outline-none bg-transparent text-gray-700 px-3 py-2`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {/* <ErrorMessage name={name}> 
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
       </ErrorMessage> */}
             <button
                onClick={onFocus}
                class="bg-baseColor-primary text-white rounded-md px-3 py-2 hover:bg-green-800 transition-colors focus:outline-none"
                type="submit"
              >
                Add
              </button>
    </div>
  );
}

export function NuInputReffrence(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,disabled,
    width,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  // console.log(max, "date");
  return (
    <div className={`bg-white border border-gray-300 rounded-md shadow-sm mt-2`}>
      {/* <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label> */}
      <input
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `w-full h-8 outline-none bg-transparent text-gray-700 px-2`
        }
        multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {/* <ErrorMessage name={name}> 
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
       </ErrorMessage> */}
             {/* <button
                class="bg-baseColor-primary text-white rounded-full px-3 py-2 hover:bg-green-600 transition-colors focus:outline-none"
                type="submit"
              >
                Add
              </button> */}
    </div>
  );
}




export function NuTextArea(props) {
  let {
    name,
    placeholder,
    label,
    formik,
    handleBlur,
    handleChange,
    isRequired,
    value,
    new_width="w-full lg:w-[50%]",
  } = props;
  return (
    <div className={`relative px-6 py-2 ${new_width?new_width:"lg:w-[67%]"}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label} {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        type="text"
        value={value || formik?.values[name]}
        onChange={handleChange||formik?.handleChange}
        onBlur={handleBlur}
        className={
          "text-input error text-xs 2xl:text-sm font-medium border w-full h-20 px-3 py-2 mt-2 rounded-[10px] outline-none"
        }
      ></textarea>
      {/* <ErrorMessage name={name}> */}
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
      {/* </ErrorMessage> */}
    </div>
  );
}

export function NuTextAreaForm(props) {
  let {
    name,
    placeholder,
    label,
    formik,
    handleBlur,
    handleChange,
    isRequired,
    value,
    new_width="w-full ",
  } = props;
  return (
    <div className={`relative px-0 py-2 ${new_width?new_width:"lg:w-[67%]"}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label} {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        type="text"
        value={value || formik?.values[name]}
        onChange={handleChange||formik?.handleChange}
        onBlur={handleBlur}
        className={
          "text-input error text-xs 2xl:text-sm font-medium border w-full h-16 px-3 py-2  rounded-[10px] outline-none"
        }
      ></textarea>
      {/* <ErrorMessage name={name}> */}
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
      {/* </ErrorMessage> */}
    </div>
  );
}

export function OnlyInput(props) {
  let { inputType, name, ClassName, placeholder, onChange } = props;
  return (
    <input type={inputType} className={ClassName} placeholder={placeholder} />
  );
}





// Fallback list of common timezones
// const fallbackTimezones = [
//   "UTC",
//   "America/New_York",
//   "America/Los_Angeles",
//   "Europe/London",
//   "Asia/Tokyo",
//   "Asia/Kolkata",
//   "Australia/Sydney",
//   "Pacific/Auckland",
//   "America/Chicago",
//   "Europe/Paris",
// ];

// // NuDateTime Component
// export function NuDateTime(props) {
//   const {
//     name,
//     placeholder,
//     label,
//     formik,
//     max,
//     min,
//     value,
//     isRequired,
//     onChange,
//     disabled,
//     width,
//     defaultValues,
//   } = props;

//   const formikValues = formik ? formik.values[name] : "";
//   const formikErrors = formik && formik.errors ? formik.errors[name] : null;

//   // Format the value for the datetime-local input
//   const displayValue = formikValues || value || defaultValues
//     ? moment(formikValues || value || defaultValues).format("YYYY-MM-DDTHH:mm")
//     : "";

//   const handleDateChange = (e) => {
//     const newValue = e.target.value;
//     if (newValue) {
//       const formatted = moment(newValue).toISOString();
//       if (formik) {
//         formik.setFieldValue(name, formatted);
//       }
//       if (onChange) {
//         onChange(formatted);
//       }
//     }
//   };

//   return (
//     <div className={`px-6 py-2 ${width}`}>
//       <label htmlFor={name} className="text-xs 2xl:text-sm">
//         {label}
//         {isRequired ? <span className="text-red-500"> *</span> : ""}
//       </label>
//       <input
//         disabled={disabled}
//         placeholder={placeholder}
//         type="datetime-local"
//         name={name}
//         max={max || ""}
//         min={min || ""}
//         value={displayValue}
//         onChange={handleDateChange}
//         className="text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none disabled:bg-gray-100"
//       />
//       {formikErrors ? (
//         <span className="text-xs font-semibold text-red-500">{formikErrors}</span>
//       ) : null}
//     </div>
//   );
// }

// // NuTimeZone Component
// export function NuTimeZone(props) {
//   const {
//     name,
//     placeholder,
//     label,
//     formik,
//     value,
//     isRequired,
//     onChange,
//     disabled,
//     width,
//   } = props;

//   const formikValues = formik ? formik.values[name] : "";
//   const formikErrors = formik && formik.errors ? formik.errors[name] : null;

//   // Use moment.tz.names() if available, otherwise fallback
//   const timezones = moment.tz && moment.tz.names ? moment.tz.names() : fallbackTimezones;

//   const handleTimeZoneChange = (e) => {
//     const newValue = e.target.value;
//     if (formik) {
//       formik.setFieldValue(name, newValue);
//     }
//     if (onChange) {
//       onChange(newValue);
//     }
//   };

//   return (
//     <div className={`px-6 py-2 ${width}`}>
//       <label htmlFor={name} className="text-xs 2xl:text-sm">
//         {label}
//         {isRequired ? <span className="text-red-500"> *</span> : ""}
//       </label>
//       <select
//         disabled={disabled}
//         name={name}
//         value={value || formikValues || "UTC"}
//         onChange={handleTimeZoneChange}
//         className="text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none disabled:bg-gray-100"
//       >
//         <option value="" disabled>
//           {placeholder}
//         </option>
//         {timezones.map((tz) => (
//           <option key={tz} value={tz}>
//             {tz} (UTC{moment.tz(tz).format("Z")})
//           </option>
//         ))}
//       </select>
//       {formikErrors ? (
//         <span className="text-xs font-semibold text-red-500">{formikErrors}</span>
//       ) : null}
//     </div>
//   );
// }
export function NuDate(props) {
  const {
    name,
    placeholder,
    label,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    onChange,disabled,
    width
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  return (
    <div className={`px-6  py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type="date"
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          "text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none"
        }
        // multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}

export function NuDateSmall(props) {
  const {
    name,
    placeholder,
    label,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    onChange,disabled,
    width
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  return (
    <div className={`px-1  py-1 ${width}`}>
      <label htmlFor={name} className="text-xs">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type="date"
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          "text-xs  font-medium border w-full h-9 px-3 rounded-[10px] outline-none"
        }
        // multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}




export function NuTime(props) {
  const {
    name,
    placeholder,
    label,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    onChange,disabled,
    width
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  return (
    <div className={`px-6 py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type="time"
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          "text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none"
        }
        // multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}


export function NuDataTime(props) {
  const {
    name,
    placeholder,
    label,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    onChange,disabled,
    width,
    defaultValues
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  return (
    <div className={`px-6 py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type="datetime-local"
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues || defaultValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          "text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none"
        }
        // multiple
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
    </div>
  );
}

export function NuFormTextArea(props) {
  let {
    name,
    placeholder,
    formik,
    handleBlur,
    handleChange,
    isRequired,
    value,
    new_width="w-full lg:w-[50%]",
    field_type,
    allValue,
    setAllValue=()=>{},
    id,
    label,
    disabled
  } = props;

  const handleChangeFunc =(e)=>{

console.log("e ",e.target.value);



  let tempValue = {
    id: id,
    field_type: field_type,    
};

if(field_type === "multi"){
  if(allValue.some((item) => item.id === id)){
    let values = allValue.find((item) => item.id === id);
    tempValue = values;
    tempValue.value = {
      ...tempValue.value,
      [label]: e.target.value,
    }
  }else{
    tempValue.value = {
      [label]: e.target.value,
    }
  }
}else{
  tempValue.value=e.target.value;
}

  if (e.target.value) {
    // First filter out any existing item with this id
    const filteredValues = allValue.filter((item) => item.id !== id);
    // Then add the new value
    setAllValue([...filteredValues, tempValue]);
} else {
   if(field_type === "multi"){
    tempValue.value = {
      ...tempValue.value,
      [label]: "",
    }
   }else{
    tempValue.value="";
   }
   const filteredValues = allValue.filter((item) => item.id !== id);
   setAllValue([...filteredValues, tempValue]);
}
  } 

  let ValueInForm = allValue.find((item) => (item.id === id && item.field_type === field_type))
  let FinalValue = ""
   if(field_type === "multi"){
     FinalValue = ValueInForm?.value[label] || ""
   }else{
     FinalValue = ValueInForm?.value
   }
   
  return (


    <div className={`relative px-6 py-2 ${new_width?new_width:"lg:w-[67%]"}`}>
      <textarea
        id={name}
        disabled={disabled}
        name={name}
        placeholder={placeholder}
        type="text"
        value={FinalValue}
        onChange={handleChangeFunc}
        onBlur={handleBlur}
        className={
          "text-input error text-xs 2xl:text-sm font-medium border w-full h-20 px-3 py-2 mt-2 rounded-[10px] outline-none"
        }
      ></textarea>
    </div>
  );
}

export function NuFormInput(props) {
  let {
    name,
    placeholder,
    handleChange,
    formik,
    max,
    min,
    value,
    type,
    onChange,disabled,
    width,
    px= "0.5",
    field_type,
    allValue,
    setAllValue=()=>{},
    id,
    label,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc =(e)=>{


    let tempValue = {
      id: id,
      field_type: field_type,    
  };

  if(field_type === "multi"){
    if(allValue.some((item) => item.id === id)){
      let values = allValue.find((item) => item.id === id);
      tempValue = values;
      tempValue.value = {
        ...tempValue.value,
        [label]: e.target.value,
      }
    }else{
      tempValue.value = {
        [label]: e.target.value,
      }
    }
  }else{
    tempValue.value=e.target.value;
  }

  

  if (e.target.value) {
    // First filter out any existing item with this id
    const filteredValues = allValue.filter((item) => item.id !== id);
    // Then add the new value
    setAllValue([...filteredValues, tempValue]);
} else {
  if(field_type === "multi"){
    tempValue.value = {
      ...tempValue.value,
      [label]: "",
    }
   }else{
    tempValue.value="";
   }
   const filteredValues = allValue.filter((item) => item.id !== id);
   setAllValue([...filteredValues, tempValue]);
}
  } 
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  let ValueInForm = allValue?.find((item) => (item.id === id && item.field_type === field_type))
 let FinalValue = ""
  if(field_type === "multi"){
    FinalValue = ValueInForm?.value[label] || ""
  }else{
    FinalValue = ValueInForm?.value
  }
 

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={FinalValue||""}
        onChange={handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs  font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${disabled === true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
    </div>
  );
}
export function NuFormInputNew(props) {
  let {
    name,
    placeholder,
    handleChange,
    formik,
    max,
    min,
    value,
    type,
    onChange,
    disabled,
    width,
    px = "0.5",
    field_type,
    allValue = [], // Default to an empty array to prevent undefined issues
    setAllValue = () => {},
    id,
    label,
  } = props;

  // Debug: Log allValue to inspect its value
  console.log("allValue:", allValue, "Type:", typeof allValue);

  const formikValues = formik ? formik.values[name] : "";

  const handleChangeFunc = (e) => {
    let tempValue = {
      id: id,
      field_type: field_type,
    };

    if (field_type === "multi") {
      // Check if allValue is an array before using array methods
      if (Array.isArray(allValue) && allValue.some((item) => item.id === id)) {
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.value,
        };
      } else {
        tempValue.value = {
          [label]: e.target.value,
        };
      }
    } else {
      tempValue.value = e.target.value;
    }

    if (e.target.value) {
      // First filter out any existing item with this id
      const filteredValues = Array.isArray(allValue)
        ? allValue.filter((item) => item.id !== id)
        : [];
      // Then add the new value
      setAllValue([...filteredValues, tempValue]);
    } else {
      if (field_type === "multi") {
        tempValue.value = {
          ...tempValue.value,
          [label]: "",
        };
      } else {
        tempValue.value = "";
      }
      const filteredValues = Array.isArray(allValue)
        ? allValue.filter((item) => item.id !== id)
        : [];
      setAllValue([...filteredValues, tempValue]);
    }
  };

  const formikErrors = formik && formik.errors ? formik.errors[name] : null;

  // Ensure allValue is an array before calling find
  let ValueInForm = Array.isArray(allValue)
    ? allValue.find((item) => item.id === id && item.field_type === field_type)
    : null;

  let FinalValue = "";
  if (field_type === "multi") {
    FinalValue = ValueInForm?.value?.[label] || "";
  } else {
    FinalValue = ValueInForm?.value || "";
  }

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input
        disabled={disabled ? true : false}
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={FinalValue || ""}
        onChange={handleChangeFunc}
        className={`text-xs font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${
          disabled === true ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        multiple
      />
    </div>
  );
}
export function NuTableFormInput(props) {
  const {
    name,
    placeholder,
    max,
    min,
    type,
    disabled,
    width,
    px = "0.5",
    field_type,
    allValue,
    setAllValue = () => {},
    id,
    label,
    idx
  } = props;

  const handleChangeFunc = (e) => {
    const inputValue = e.target.value;
    let updatedValue;

    if (field_type === "tableItems") {
      const existingField = allValue.find((item) => item.id === id);
      const fieldValues = existingField?.value || [];
      const existingItem = fieldValues.find((item) => item.id === idx);
      let updatedFieldValues = []
      if(existingItem){
        updatedFieldValues = [
        ...fieldValues.filter((item) => item.id !== idx),
        { ...existingItem, [label]: inputValue }
      ];
      }else{
        updatedFieldValues = [
          ...fieldValues,
          { id: idx, [label]: inputValue }
        ];
      }
      // Update or insert the item at `idx`
      updatedValue = {
        id,
        field_type,
        value: updatedFieldValues
      };      
    } else {
      updatedValue = {
        id,
        field_type,
        value: inputValue
      };
    }

    // Update allValue by replacing or appending
    const updatedAllValue = [
      ...allValue.filter((item) => item.id !== id),
      updatedValue
    ];

    setAllValue(updatedAllValue);
  };

const valueInForm = allValue.find(
  (item) => item.id === id && item.field_type === field_type
);

let finalValue = "";

if (field_type === "tableItems") {
  if (Array.isArray(valueInForm?.value)) {
    finalValue = valueInForm.value.find((v) => v.id === idx)?.[label] || "";
  }
} else {
  finalValue = valueInForm?.value || "";
}

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input
        disabled={!!disabled}
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={finalValue}
        onChange={handleChangeFunc}
        className={`text-xs font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${
          disabled ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
      />
    </div>
  );
}

export function NuTableFormTextArea(props) {
  let {
    name,
    placeholder,
    new_width="w-full",
    field_type,
    allValue,
    setAllValue=()=>{},
    id,
    label,
    disabled,
    idx
  } = props;

  const handleChangeFunc = (e) => {
    const inputValue = e.target.value;
    let updatedValue;

    if (field_type === "tableItems") {
      const existingField = allValue.find((item) => item.id === id);
      const fieldValues = existingField?.value || [];
      const existingItem = fieldValues.find((item) => item.id === idx);
      let updatedFieldValues = []
      if(existingItem){
        updatedFieldValues = [
        ...fieldValues.filter((item) => item.id !== idx),
        { ...existingItem, [label]: inputValue }
      ];
      }else{
        updatedFieldValues = [
          ...fieldValues,
          { id: idx, [label]: inputValue }
        ];
      }
      // Update or insert the item at `idx`
      updatedValue = {
        id,
        field_type,
        value: updatedFieldValues
      };      
    } else {
      updatedValue = {
        id,
        field_type,
        value: inputValue
      };
    }

    // Update allValue by replacing or appending
    const updatedAllValue = [
      ...allValue.filter((item) => item.id !== id),
      updatedValue
    ];

    setAllValue(updatedAllValue);
  };

const valueInForm = allValue.find(
  (item) => item.id === id && item.field_type === field_type
);

let finalValue = "";

if (field_type === "tableItems") {
  if (Array.isArray(valueInForm?.value)) {
    finalValue = valueInForm.value.find((v) => v.id === idx)?.[label] || "";
  }
} else {
  finalValue = valueInForm?.value || "";
}
   
  return (


    <div className={`relative  py-2 ${new_width?new_width:"lg:w-[67%]"}`}>
      <textarea
        id={name}
        disabled={disabled}
        name={name}
        placeholder={placeholder}
        type="text"
        value={finalValue}
        onChange={handleChangeFunc}
        className={
          "text-input error text-xs 2xl:text-sm font-medium border w-full h-20 px-3 py-2 mt-2 rounded-[10px] outline-none"
        }
      ></textarea>
    </div>
  );
}



export function NuRowFormInput(props) {
  const {
    name,
    placeholder,
    max,
    min,
    type,
    disabled,
    width,
    px = "0.5",
    field_type,
    allValue,
    setAllValue = () => {},
    id,
    label,
  } = props;

  const handleChangeFunc = (e) => {
    const inputValue = e.target.value;
    let updatedValue;

    if (field_type === "tableRow") {
      const existingField = allValue.find((item) => item.id === id);
      const fieldValues = existingField?.value || {};
      const existingItem = fieldValues[label];
      let updatedFieldValues = {}
      if(existingItem){
        updatedFieldValues = {
          ...fieldValues,
          [label]: inputValue
        }
      }else{
        updatedFieldValues =
          { 
            ...fieldValues,
            [label]: inputValue 
          }
        ;
      }
      // Update or insert the item at `idx`
      updatedValue = {
        id,
        field_type,
        value: updatedFieldValues
      };      
    } else {
      updatedValue = {
        id,
        field_type,
        value: inputValue
      };
    }

    // Update allValue by replacing or appending
    const updatedAllValue = [
      ...allValue.filter((item) => item.id !== id),
      updatedValue
    ];

    console.log("Updated All Value", updatedValue);

    setAllValue(updatedAllValue);
  };

const valueInForm = allValue.find(
  (item) => item.id === id && item.field_type === field_type
);

let finalValue = "";

if (field_type === "tableRow") {
    finalValue = valueInForm.value[label] || "";
} else {
  finalValue = valueInForm?.value || "";
}

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input
        disabled={!!disabled}
        placeholder={placeholder}
        type={type}
        name={name}
        max={max || ""}
        min={min || ""}
        value={finalValue}
        onChange={handleChangeFunc}
        className={`text-xs font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${
          disabled ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
      />
    </div>
  );
}
export function NuFormInputNumberNew(props) {
  let {
    name,
    placeholder,
    handleChange,
    formik,
    max,
    min,
    value,
    type,
    onChange,
    disabled,
    width,
    px = "0.5",
    field_type,
    allValue = [], // Default to an empty array to prevent undefined issues
    setAllValue = () => {},
    id,
    label,
  } = props;

  // Debug: Log allValue to inspect its value
  console.log("allValue in NuFormInputNumber:", allValue, "Type:", typeof allValue);

  const formikValues = formik ? formik.values[name] : "";

  const handleChangeFunc = (e) => {
    let tempValue = {
      id: id,
      field_type: field_type,
    };

    if (field_type === "multi") {
      // Check if allValue is an array before using array methods
      if (Array.isArray(allValue) && allValue.some((item) => item.id === id)) {
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.value,
        };
      } else {
        tempValue.value = {
          [label]: e.target.value,
        };
      }
    } else {
      tempValue.value = e.target.value;
    }

    if (e.target.value) {
      // First filter out any existing item with this id
      const filteredValues = Array.isArray(allValue)
        ? allValue.filter((item) => item.id !== id)
        : [];
      // Then add the new value
      setAllValue([...filteredValues, tempValue]);
    } else {
      if (field_type === "multi") {
        tempValue.value = {
          ...tempValue.value,
          [label]: "",
        };
      } else {
        tempValue.value = "";
      }
      const filteredValues = Array.isArray(allValue)
        ? allValue.filter((item) => item.id !== id)
        : [];
      setAllValue([...filteredValues, tempValue]);
    }
  };

  const formikErrors = formik && formik.errors ? formik.errors[name] : null;

  // Ensure allValue is an array before calling find
  let ValueInForm = Array.isArray(allValue)
    ? allValue.find((item) => item.id === id && item.field_type === field_type)
    : null;

  let FinalValue = "";
  if (field_type === "multi") {
    FinalValue = ValueInForm?.value?.[label] || "";
  } else {
    FinalValue = ValueInForm?.value || "";
  }

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input
        disabled={disabled ? true : false}
        placeholder={placeholder}
        type="number"
        name={name}
        max={max || ""}
        min={min || ""}
        value={FinalValue || ""}
        onChange={handleChangeFunc}
        className={`text-xs font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${
          disabled === true ? "bg-slate-100 cursor-not-allowed" : ""
        }`}
        multiple
      />
    </div>
  );
}

export function NuFormInputNumber(props) {
  let {
    name,
    placeholder,
    handleChange,
    formik,
    max,
    min,
    value,
    type,
    onChange,disabled,
    width,
    px= "0.5",
    field_type,
    allValue,
    setAllValue=()=>{},
    id,
    label,
  } = props;
  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc =(e)=>{


    let tempValue = {
      id: id,
      field_type: field_type,    
  };

  if(field_type === "multi"){
    if(allValue.some((item) => item.id === id)){
      let values = allValue.find((item) => item.id === id);
      tempValue = values;
      tempValue.value = {
        ...tempValue.value,
        [label]: e.target.value,
      }
    }else{
      tempValue.value = {
        [label]: e.target.value,
      }
    }
  }else{
    tempValue.value=e.target.value;
  }

  

  if (e.target.value) {
    // First filter out any existing item with this id
    const filteredValues = allValue.filter((item) => item.id !== id);
    // Then add the new value
    setAllValue([...filteredValues, tempValue]);
} else {
  if(field_type === "multi"){
    tempValue.value = {
      ...tempValue.value,
      [label]: "",
    }
   }else{
    tempValue.value="";
   }
   const filteredValues = allValue.filter((item) => item.id !== id);
   setAllValue([...filteredValues, tempValue]);
}
  } 
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;
  let ValueInForm = allValue.find((item) => (item.id === id && item.field_type === field_type))
 let FinalValue = ""
  if(field_type === "multi"){
    FinalValue = ValueInForm?.value[label] || ""
  }else{
    FinalValue = ValueInForm?.value
  }
 

  return (
    <div className={`px-${px} py-2 ${width}`}>
      <input disabled={disabled ? true : false}
          // id={name} 
        placeholder={placeholder}
        type="number"
        name={name}
        max={max || ""}
        min={min || ""}
        value={FinalValue||""}
        onChange={handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs  font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-baseColor-primary ${disabled === true? "bg-slate-100 cursor-not-allowed":""}`
        }
        multiple
      />
    </div>
  );
}



export function InputCheck({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    let TempDetail = allValue.find((item) => item.id === id)
    let valueofTemp = TempDetail;
    console.log("VALUES",value);
    
    let tempValue = {
        id: id,
        field_type: field_type,
        ...valueofTemp
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.checked,
        }
      }else{
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.checked,
        }
      }
    }else{
       tempValue.value = {
          ...tempValue.value,
          [e.target.name]: e.target.checked,
        }
      // tempValue.value=e.target.checked;
    }

    console.log("Temp Value -1",tempValue);
    

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      // if(field_type === "multi"){
      //   tempValue.value = {
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   }
      //  }else{
      //   tempValue.value={
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   };
      //  }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    
}
  //  console.log("All Value", allValue);
    // console.log("All label", label);
const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && item.value?.[label] === true)
    : allValue.some((item) => item.id === id && item.value?.[label] === true);
    // console.log("is Checked",isChecked);
    
  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}

export function InputCheckYes({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    let TempDetail = allValue.find((item) => item.id === id)
    let valueofTemp = TempDetail;
    console.log("VALUES",valueofTemp);
    console.log(allValue,"-all values");
    console.log(id,"id");
    
    
    let tempValue = {
        id: id,
        field_type: field_type,
        ...valueofTemp
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        console.log("Values ---- ===",values);
        
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: true,
        }
      }else{
        tempValue.value = {
          ...tempValue.value,
          [label]: true,
        }
      }
    }else{
       tempValue.value = true
    }


    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      // if(field_type === "multi"){
      //   tempValue.value = {
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   }
      //  }else{
      //   tempValue.value={
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   };
      //  }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    
}
  //  console.log("All Value", allValue);
    // console.log("All label", label);
const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && (item?.value?.[label] === true||item.value?.[label] === "1"))
    : allValue.some((item) => item.id === id && (item?.value === true||item.value === "1"));
    // console.log("is Checked",isChecked);
    
    console.log("All Value", isChecked);

  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}

export function InputCheckNo({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    let TempDetail = allValue.find((item) => item.id === id)
    let valueofTemp = TempDetail;
    console.log("VALUES",value);
    
    let tempValue = {
        id: id,
        field_type: field_type,
        ...valueofTemp
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: false,
        }
      }else{
        tempValue.value = {
          ...tempValue.value,
          [label]: false,
        }
      }
    }else{
       tempValue.value = false
      // tempValue.value=e.target.checked;
    }

    console.log("Temp Value -1",tempValue);
    

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      // if(field_type === "multi"){
      //   tempValue.value = {
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   }
      //  }else{
      //   tempValue.value={
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   };
      //  }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    
}
  //  console.log("All Value", allValue);
    // console.log("All label", label);
const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && (item.value?.[label] === false||item.value?.[label] === "0"))
    : allValue.some((item) => item.id === id && (item.value === false||item.value === "0"));
    // console.log("is Checked",isChecked);
    
  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}

export function InputCheckNone({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    let TempDetail = allValue.find((item) => item.id === id)
    let valueofTemp = TempDetail;
    console.log("VALUES",value);
    
    let tempValue = {
        id: id,
        field_type: field_type,
        ...valueofTemp
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: null,
        }
      }else{
        tempValue.value = {
          ...tempValue.value,
          [label]: null,
        }
      }
    }else{
       tempValue.value = null
      // tempValue.value=e.target.checked;
    }

    console.log("Temp Value -1",tempValue);
    

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      // if(field_type === "multi"){
      //   tempValue.value = {
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   }
      //  }else{
      //   tempValue.value={
      //     ...tempValue.value,
      //     [e.target.name]: false,
      //   };
      //  }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    
}
  //  console.log("All Value", allValue);
    // console.log("All label", label);
const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && item.value?.[label] === null)
    : allValue.some((item) => item.id === id && item.value === null);
    // console.log("is Checked",isChecked);
    
  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}


export function InputCheckTure({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    
    let tempValue = {
        id: id,
        field_type: field_type,
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.checked,
        }
      }else{
        tempValue.value = {
          [label]: e.target.checked,
        }
      }
    }else{
      tempValue.value=e.target.checked;
    }

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      if(field_type === "multi"){
        tempValue.value = {
          ...tempValue.value,
          [label]: "",
        }
       }else{
        tempValue.value="";
       }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    console.log("All Value", allValue);
}

const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && item.value?.[label] === name)
    : allValue.some((item) => item.id === id && item.value === name);
  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}

export function InputSingleCheck({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  label,
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.value);
    console.log(field_type);
    console.log(id);
    
    let tempValue = {
        id: id,
        field_type: field_type,
    };
    if(field_type === "multi"){
      if(allValue.some((item) => item.id === id)){
        let values = allValue.find((item) => item.id === id);
        tempValue = values;
        tempValue.value = {
          ...tempValue.value,
          [label]: e.target.checked,
        }
      }else{
        tempValue.value = {
          [label]: e.target.checked,
        }
      }
    }else{
      if(e.target.name == "Yes"){
        tempValue.value={
          "Yes":e.target.checked,
          "No":false
        }
      }else if(e.target.name == "No"){
        tempValue.value={
          "Yes":false,
          "No":e.target.checked
        }
      }
      
    }

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {

      if(field_type === "multi"){
        tempValue.value = {
          ...tempValue.value,
          [label]: "",
        }
       }else{
        tempValue.value="";
       }
       const filteredValues = allValue.filter((item) => item.id !== id);
       setAllValue([...filteredValues, tempValue]);
    }
    
    console.log("All Value", allValue);
}

const isChecked = field_type === "multi"
    ? allValue.some((item) => item.id === id && item.value?.[label] === true)
    : allValue.some((item) => item.id === id && item.value?.[label] === true);
  return (
    <div>
      <input
      
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={isChecked}
      />
    </div>
  );
}


export function NuFormInputCheck({
  type,
  classname,
  placeholder,
  value,
  name,
  id,
  onchange,
  onclick,
  formik,
  field_type,
  allValue,
  setAllValue=()=>{},
  disabled,
  fullValue
}) {
  function handleChange(e) {
    console.log("Name", e.target.name, "Value", e.target.checked);
    console.log(field_type);
    console.log(id);
    
    let tempValue = {
        id: id,
        field_type: field_type,
        value: {
          ...fullValue,
          [e.target.name]:e.target.checked
        }, // Should this be e.target.value?
    };
console.log("Temp Value", tempValue);

    if (e.target.checked) {
        // First filter out any existing item with this id
        const filteredValues = allValue.filter((item) => item.id !== id);
        // Then add the new value
        setAllValue([...filteredValues, tempValue]);
    } else {
        // Remove the item if unchecked
        setAllValue(allValue.filter((item) => item.id !== id));
    }
    
    console.log("All Value", allValue);
}
  return (
    <div>
      <input
        type="checkbox"
        disabled={disabled}
        className={classname}
        placeholder={placeholder}
        value={value}
        name={name}
        id={id}
        onChange={handleChange}
        checked={allValue.some((item) => item.id === id && item.value[name])}
      />
    </div>
  );
}


function Input({
  type,
  classname,
  placeholder,
  name,
  id,
  onchange,
  onclick,
  label,
  labelclassname,
  handlechange,
  customClass,
  formik,
}) {
  return (
    <div className={`${customClass}`}>
      <label className={`${labelclassname} text-xs 2xl:text-sm`}>{label}</label>
      <input
        type={type}
        className={`${classname} text-xs 2xl:text-sm font-medium`}
        placeholder={placeholder}
        value={formik?.values[name] || ""}
        name={name}
        id={id}
        onChange={onchange}
        onClick={onclick}
        handleChange={handlechange}
      />
      {formik?.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik?.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export default Input;

export function NuFormSelect(props) {
  let { 
    label="",
    name, 
    value,  
    options=[], 
    optionName="",
    field_type,
    allValue=[],
    id,
    setAllValue=()=>{},
    disabled,
   } =
    props;
    function handleChange(e) {
      const inputValue = e.target.value;
      let updatedValue;
      if(field_type=="multi"){
      const existingField = allValue.find((item) => item.id === id);
      const fieldValues = existingField?.value || {};
      const existingItem = fieldValues[label];
      let updatedFieldValues = {}
      if(existingItem){
        updatedFieldValues = {
          ...fieldValues,
          [label]: inputValue
        }
      }else{
      updatedFieldValues =
          { 
            ...fieldValues,
            [label]: inputValue 
          }
      }
      updatedValue = {
        id,
        field_type,
        value: updatedFieldValues
      };  

      }else {
      updatedValue = {
        id,
        field_type,
        value: inputValue
      };
    }
        const updatedAllValue = [
      ...allValue.filter((item) => item.id !== id),
      updatedValue
    ];

    console.log("Updated All Value", updatedValue);

    setAllValue(updatedAllValue);
      
    }

    const valueInForm = allValue.find(
  (item) => item.id === id && item.field_type === field_type
);

let finalValue = "";

if (field_type === "multi") {
    finalValue = valueInForm?.value[label] || "";
    console.log("value",finalValue);
    
} else {
  finalValue = valueInForm?.value || "";
}

  return (
    <div className="relative py-2 lg:py-0 w-full ">
      <select
        value={finalValue}
        className={
          "text-xs  font-medium border w-full h-10 px-3 mt-2 rounded-lg capitalize outline-none"
        }
        name={name}
        id={name}
        onChange={handleChange}
        disabled={!!disabled}
      >
        <option key="">Select {optionName}</option>
        {options && options.map((option,indx) => (
          <option key={`${indx}+${option.value}`} value={option.value}>{option.label}</option>
        ))}
      </select>
      {/* <ErrorMessage name={name}>
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
      </ErrorMessage> */}
    </div>
  );
}

export function NuTableFormSelect(props) {
  let { 
    label="",
    name, 
    value,  
    options=[], 
    optionName="",
    field_type,
    allValue=[],
    id,
    setAllValue=()=>{},
    disabled,
    idx,
   } =
    props;
    function handleChange(e) {
      const inputValue = e.target.value;
      let updatedValue;
         if (field_type === "tableItems") {
      const existingField = allValue.find((item) => item.id === id);
      const fieldValues = existingField?.value || [];
      const existingItem = fieldValues.find((item) => item.id === idx);
      let updatedFieldValues = []
      if(existingItem){
        updatedFieldValues = [
        ...fieldValues.filter((item) => item.id !== idx),
        { ...existingItem, [label]: inputValue }
      ];
      }else{
        updatedFieldValues = [
          ...fieldValues,
          { id: idx, [label]: inputValue }
        ];
      }
      // Update or insert the item at `idx`
      updatedValue = {
        id,
        field_type,
        value: updatedFieldValues
      };      
    } else {
      updatedValue = {
        id,
        field_type,
        value: inputValue
      };
    }
        const updatedAllValue = [
      ...allValue.filter((item) => item.id !== id),
      updatedValue
    ];
    setAllValue(updatedAllValue);
      
    }

    const valueInForm = allValue.find(
  (item) => item.id === id && item.field_type === field_type
);

let finalValue = "";

if (field_type === "tableItems") {
    // finalValue = valueInForm.value[label] || "";
    if (Array.isArray(valueInForm?.value)){
    finalValue = valueInForm.value.find((v) => v.id === idx)?.[label] || "";
    console.log("Final Value *******",finalValue);
    console.log("*****alll Value *******",allValue);
    }
} else {
  finalValue = valueInForm?.value || "";
   if(valueInForm.value[label]){
    console.log("Final Value if", finalValue);
    }
}



  return (
    <div className="relative py-2 lg:py-0 w-full ">
      <select
        value={finalValue}
        className={
          "text-xs  font-medium border w-full h-10 px-3 mt-2 rounded-lg capitalize outline-none"
        }
        name={name}
        id={name}
        onChange={handleChange}
        disabled={!!disabled}
      >
        <option key={""}>Select {optionName}</option>
        {options && options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
      
    </div>
  );
}

export function NuSelect(props) {
  let { name, value, label, isRequired, handleChange, options, optionName } =
    props;
  return (
    <div className="relative px-6 py-2 lg:py-0 lg:w-6/12">
      <label htmlFor={name} className=" text-xs 2xl:text-sm">
        {label} {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <select
        value={value}
        className={
          "text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-3xl capitalize outline-none"
        }
        name={name}
        id={name}
        onChange={handleChange}
      >
        <option key={""}>Select {optionName}</option>
        {options}
      </select>
      {/* <ErrorMessage name={name}>
        {(errorMsg) => (
          <div className="pt-2 text-xs font-semibold text-red-500">
            {errorMsg}
          </div>
        )}
      </ErrorMessage> */}
    </div>
  );
}

export const NuUpload = forwardRef ((props) => {
  let { 
    name, 
    label, 
    isRequired, 
    onChange, 
    // value, 
    width,
    accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.ppt,.xlsx, .pptx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv",
    multiple=false,
    ref
  } = props;
  return (
    <div className={`px-6 py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label} {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>

      <input
        ref={ref}
        id={name}
        name={name}
        onChange={onChange}
        type="file"
        accept={accept}
        multiple={multiple}
        className="mt-2 cursor-pointer block w-full text-sm text-slate-500
        file:mr-4 file:py-[9px] file:px-4 file:rounded-l-md
        file:border-0 file:text-sm file:font-semibold
        file:bg-gray-200 file:text-gray-700
        hover:file:bg-gray-400 file:cursor-pointer border rounded-[10px] h-10"
      />

    </div>
  );
})






export const NuMobileNumber = ({ label, name, nunCode, formik, onChange, placeholder, width, isRequired, disable, min, max,  FixPosition=false,
  PortalTarget= false }) => {
  const handleChange = (selectedOption) => {
    formik.handleChange({
      target: {
        value: selectedOption.value,
        name: nunCode,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,

      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      marginTop:"8px",
      fontSize:'13px',
      fontWeight: "500",
      // width: "250px",
      
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",  // Default padding
      fontSize: "12px",  // Default font size for small screens
      [`@media (min-width: 640px)`]: {
        fontSize: "12px",  // sm breakpoint (Tailwind sm: text-sm)
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px",  // md breakpoint (Tailwind md: text-base)
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px",  // lg breakpoint (Tailwind lg: text-lg)
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px",  // lg breakpoint (Tailwind lg: text-lg)
      },
      color: state.isSelected ? '#fff' : '#000',  // Custom colors for selected options
      backgroundColor: state.isSelected ? '#2563EB' : '#fff',  // Custom background color for selected option
      ':hover': {
        color:'#fff',
        backgroundColor: '#60A5FA',  // Hover state color
      },
    }),
  };

  return (
    <div className={`px-6 py-2 ${width}`}>
      <div className=''>
        <label className='text-xs 2xl:text-sm'>
          {label}
          {isRequired ? <span className="text-red-500">*</span> : ""}
        </label>
        <div className='flex items-center gap-1'>
          <ReactSelect
            className='w-36'
            styles={styles}
            options={mobileCode}
            value={mobileCode.find((i) => i.value == formik.values[nunCode]) || ""}
            onChange={handleChange}
            isDisabled={disable}
            placeholder={"00"}
            menuPosition={FixPosition==true?"fixed":"absolute"}
            menuPortalTarget={PortalTarget==true?document.body:""}
          />
          <input
            className='text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none'
            name={name}
            placeholder={placeholder}
            value={formik.values[name] || ""}
            type='number'
            onChange={formik.handleChange||onChange}
            max={max}
            min={min}
            disabled={disable ? true : false}
          />
        </div>
        {(formik.errors[name] && <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span>) ||
          (formik.values[name] && formik.values[nunCode] === "" && <span className='text-xs font-semibold text-red-500'>Select Country Code</span>)}
      </div>
    </div>
  );
};



export function NuInputCheck(props) {
  let {
    name,
    placeholder,
    label,
    handleBlur,
    handleChange,
    formik,
    max,
    min,
    value,
    isRequired,
    type,
    onChange,
    disabled,
    width,
    url=""
  } = props;

  const [hasError, setHasError] = useState(false);
  const [wasSuccess, setWasSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [timeoutId, setTimeoutId] = useState(null); // State to hold timeout ID

  const formikValues = formik ? formik.values[name] : "";
  const handleChangeFunc = formik ? formik.handleChange : handleChange;
  const formikErrors = formik && formik.errors ? formik.errors[name] : null;

  useMemo(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (formikValues !== "") {
      const newTimeoutId = setTimeout(() => {
        checkRefNumber(formikValues);
      }, 1000);
      
      setTimeoutId(newTimeoutId);
    } else {
      setHasError(false);
      setWasSuccess(false);
      setMessage("");
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [formikValues]);

  function checkRefNumber(value) {
    axiosInstance.get(`${url}=${value}`).then(res => {
      if (res.data?.status) {
        setWasSuccess(true);
        setHasError(false);
        setMessage("");
      } else {
        setWasSuccess(false);
        setHasError(true);
        setMessage(res.data?.msg);
      }
    }).catch(err => {
      setHasError(true);
      setWasSuccess(false);
    });
  }

  return (
    <div className={`px-6 py-2 ${width}`}>
      <label htmlFor={name} className="text-xs 2xl:text-sm">
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
        {wasSuccess ? <div className="w-3 h-3 inline-block ml-4 bg-green-400 rounded-full"></div> : null}
        {hasError ? <div className="w-3 h-3 inline-block ml-4 bg-red-400 rounded-full"></div> : null}
      </label>
      <input
        disabled={disabled ? true : false}
        // id={name} 
        placeholder={placeholder}
        type="text"
        name={name}
        max={max || ""}
        min={min || ""}
        value={value || formikValues}
        onChange={onChange || handleChangeFunc}
        // onBlur={handleBlur}
        className={
          `text-xs 2xl:text-sm font-medium border w-full h-10 px-3 mt-2 rounded-[10px] outline-none ${disabled == true ? "bg-slate-100 cursor-not-allowed" : ""}`
        }
      />
      {formikErrors ? (
        <span className="text-xs font-semibold text-red-500">
          {formikErrors}
        </span>
      ) : null}
      {
        hasError ? <span className="text-xs font-semibold text-red-500"> {message ? message : `${label} was already exist !`}</span> : null
      }
    </div>
  );
}



export function NuChatArea(props) {
  let {
    name,
    formik,
    handleBlur,
    handleChange,
    value,
    placeholder
  } = props;

  const adjustTextareaHeight = (e) => {
    const textarea = e.target;
    textarea.style.height = 'auto';
    const maxHeight = 65;
    const height = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = `${height}px`;
    textarea.style.overflowY = height >= maxHeight ? 'scroll' : 'hidden';
  };

  return (
    <div className="relative px-1 py-2 lg:w-full">
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        type="text"
        value={value || formik.values[name]}
        onChange={handleChange || formik.handleChange}
        onBlur={handleBlur}
        className={
          " text-xs  border w-full px-3 py-1 mt-2 rounded-[10px] outline-none"
        }
        style={{ maxHeight: '65px' }}
        onInput={adjustTextareaHeight}
      ></textarea>
    </div>
  );
}



export function FormikSelect({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options = [], // Default to empty array if not provided
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const selectedOption = options.find((i) => i.value === formik?.values?.[name]);

  const handleChange = (selectedOption) => {
    formik?.setFieldValue(name, selectedOption ? selectedOption.value : '');
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      zIndex: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      [`@media (min-width: 640px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px",
      },
      color: state.isSelected ? '#fff' : '#000',
      backgroundColor: state.isSelected ? '#2563EB' : '#fff',
      ':hover': {
        color: '#fff',
        backgroundColor: '#60A5FA',
      },
    }),
  };

  return (
    <div className={`${width} relative pl-5 py-2`}>
      <label className={`${labelclassname} text-xs 2xl:text-sm`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <div className="mt-2">
        <Select
          isDisabled={disabled}
          options={options}
          value={selectedOption || ""}
          styles={styles}
          menuPortalTarget={document.body}
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
        />
      </div>
      {formik?.errors?.[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}


export const NuInputText = ({ label, name, formik={}, handleChange, width,placeholder,disable,isRequired,padding,value }) => {
  return (
    <div className={`${width} my-3  text-xs`}>
      <div className=' px-3'>
        <label className=' mb-2 font-medium text-textColor-500 '>{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Input className={padding} name={name} placeholder={placeholder} value={formik.values[name] || value || ""}  onChange={handleChange || formik.handleChange} disabled={disable?true:false}/>
        {formik.errors[name] ? <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span> : null}
      </div>
    </div>
  );
};

export const NuInputfile = ({ label, name,  handleChange, width,placeholder,disable,isRequired,acceptType="*" }) => {
  return (
    <div className={`${width} my-3 text-xs`}>
      <div className=' px-3'>
        <label className=' mb-2 font-medium text-textColor-500 '>{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Input name={name} placeholder={placeholder} type='file'  onChange={handleChange} disabled={disable?true:false} accept={acceptType} />
        {/* {formik.errors[name] ? <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span> : null} */}
      </div>
    </div>
  );
};

export const NuLabel = ({ label  }) => {
  return (
    <div className={`w-full my-4`}>
      <div className=' px-3'>
        <label className='  text-xs font-semibold'>{label}</label>
      </div>
    </div>
  );
};

export const NuSelectwithSearch = ({ label, name, formik, onChange, options, placeholder, width,isRequired }) => {
  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e,
        name: name,
      },
    });
  };

  return (
    <div className={`${width} my-3 text-xs`}>
      <div className=' px-3'>
        <label className='mb-2 font-medium text-textColor-500' >{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Select
          showSearch
          style={{ width: '100%' }}
          options={options}
          optionFilterProp="children"
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input)}
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
          }
          value={options.find((i) => i.value == formik.values[name]) || ""}
          // allowClear={formik.values[name]?true:false}
          allowClear={false}
          name={name}
          placeholder={placeholder}
          onChange={onChange || handleChange}
        />
        {formik.errors[name] ? <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span> : null}
      </div>
    </div>
  );
};

export const NuInputTextArray = ({ label, name,value, handleChange, width,placeholder,disable,isRequired,padding }) => {
  const tempFun =(e)=>{
console.log(e.target.value);
handleChange(e.target.value)
  }
  return (
    <div className={`${width} my-3  text-xs`}>
      <div className=' px-3'>
        <label className=' mb-2 font-medium text-textColor-500 '>{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Input className={padding} name={name} placeholder={placeholder} value={value||""}   onChange={(e)=>tempFun(e)} disabled={disable?true:false}/>
      </div>
    </div>
  );
};

export const NuDatePicker = ({ label, name, formik, handleChange, width,isRequired,max,min }) => {
  return (
    <div className={`${width} my-3 text-xs`}>
      <div className=' px-3'>
        <label className='mb-2 font-medium text-textColor-500'>{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Input name={name} type='date' value={formik.values[name] || ""} onChange={handleChange || formik.handleChange} min={min||""} max={max||""} />
        {formik.errors[name] ? <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span> : null}
      </div>
    </div>
  );
};


export const NuTimePicker = ({ label, name, formik, handleChange, width,isRequired,disabled,max,min }) => {
  return (
    <div className={`${width} my-3 text-xs`}>
      <div className=' px-3'>
        <label className=' mb-2 font-medium text-textColor-500'>{label}{isRequired ? <span className="text-red-500">*</span> : ""}</label>
        <Input name={name} disabled={disabled?true:false} type='time' value={formik.values[name] || ""} onChange={handleChange || formik.handleChange} max={max} min={min} />
        {formik.errors[name] ? <span className='text-xs font-semibold text-red-500'>{formik.errors[name]}</span> : null}
      </div>
    </div>
  );
};